import { TZDateMini } from '@date-fns/tz';

import { parseTimeAsTimeValue } from '@dynatrace-sdk/units';
import { getTimezone } from '@dynatrace-sdk/user-preferences';

/** @internal Number of milliseconds in one day */
export const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;

/** @internal */
export function untilMidnight(
  isoString: string | undefined,
  relativeNow?: number,
): number {
  const timezone = getTimezone();
  const date = new TZDateMini(
    parseTimeAsTimeValue(isoString, relativeNow)?.absoluteDate ?? '',
    timezone,
  );
  if (Number.isNaN(date.getTime())) {
    return ONE_DAY_IN_MILLISECONDS;
  }

  const midnight = new TZDateMini(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() + 1,
    timezone,
  );
  return midnight.getTime() - date.getTime();
}
